import './FolderCard.css';

import React, { useEffect, useState } from 'react';
import { FolderTwoTone, MoreVert } from '@mui/icons-material';
import Counter from '../../../b2b-common/Counter';
import MoreButton from '../../../b2b-common/MoreButton';
import { truncateText } from '../../../b2b-common/helpers';
import FileSizeComponent from '../files/FileSizeComponent';
import ConfirmationDialog from '../../../b2b-common/ConfirmationDialog';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const FolderCard = ({ folder, onClick, onDelete, onEdit }) => {
    const { t } = useB2BTranslation('b2b-logbook');

    const [currentFolder, setCurrentFolder] = useState(folder);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [totalFileSize, setTotalFileSize] = useState(0);

    useEffect(() => {
        setCurrentFolder(folder);

        if (folder.items && Array.isArray(folder.items)) {
            const totalSize = folder.items
                .filter(item => item.logBookItemType === 'FILE')
                .reduce((total, item) => total + item.logBookItemFileSize, 0);
            setTotalFileSize(totalSize);
        } else {
            setTotalFileSize(0);
        }
    }, [folder]);

    const handleEdit = (event) => {
        onEdit && onEdit(currentFolder);
    }

    const handleClick = () => {
        onClick && onClick(currentFolder);
    }

    const handleDeleteFolder = () => {
        onDelete && onDelete(currentFolder);
        setShowDeleteConfirmation(false);
    }

    return (
        <div className='folder-card-container'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
        >
            <div className='folder-card-icon-name'>
                <FolderTwoTone />
                <div className='folder-card-name'>
                    {currentFolder.logBookFolderName}
                </div>
            </div>
            <div className='folder-card-info'>
                <div className='folder-card-description'>
                    {truncateText(currentFolder.logBookFolderDescription, 20)}
                </div>
            </div>
            <FileSizeComponent size={totalFileSize} className='folder-card-file-size' />
            <Counter label={t('Files')} count={currentFolder.items ? currentFolder.items.length : 0} className='folder-card-item-count' />
            {isHovered && (
                <MoreButton icon={<MoreVert />} className={'folder-card-more-button'}
                    buttons={[
                        {
                            label: t('Edit'),
                            onClick: handleEdit,
                        },
                        {
                            label: t('Delete'),
                            onClick: () => setShowDeleteConfirmation(true),
                        }
                    ]}
                    rolesAllowed={['ADMIN', 'EDITOR']}
                    b2bProducts={['B2B_LOGBOOK']}
                />
            )}
            <ConfirmationDialog
                title={t('Folder Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete the selected folder?')}
                open={showDeleteConfirmation}
                onClose={() => setShowDeleteConfirmation(false)}
                onConfirm={handleDeleteFolder}
            />
        </div>
    )
}

export default FolderCard;